<template>
  <div class="flsa-panel-skeleton flsa-panel-inner px-6 pb-6 pt-4">
    <v-skeleton-loader
      type="heading"
      width="85%"
      class="mb-4 flsa-panel-skel-title"
    />

    <div class="flsa-panel-skel-description mb-4">
      <v-skeleton-loader
        type="text"
        width="100%"
        class="mb-2 flsa-panel-skel-line"
      />
      <v-skeleton-loader
        type="text"
        width="72%"
        class="flsa-panel-skel-line"
      />
    </div>

    <v-skeleton-loader
      type="text"
      width="92"
      height="16"
      class="mb-1 flsa-panel-skel-label"
    />
    <v-skeleton-loader
      type="text"
      width="100%"
      height="40"
      class="mb-4 flsa-panel-skel-field"
    />

    <v-skeleton-loader
      type="button"
      width="100%"
      height="40"
      class="flsa-panel-skel-btn"
    />

    <div
      class="flsa-panel-or-divider d-flex align-center ga-3 my-6"
      aria-hidden="true"
    >
      <div class="flsa-panel-or-line flex-grow-1" />
      <v-skeleton-loader
        type="text"
        width="32"
        height="12"
        class="flsa-panel-skel-or-label"
      />
      <div class="flsa-panel-or-line flex-grow-1" />
    </div>

    <v-skeleton-loader
      type="heading"
      width="75%"
      class="mb-4 flsa-panel-skel-section-title"
    />

    <div
      v-for="i in submissionRowCount"
      :key="i"
      class="flsa-panel-skel-row mb-4"
    >
      <v-skeleton-loader
        type="text"
        width="72"
        height="24"
        class="mb-2 flsa-panel-skel-pill"
      />
      <v-skeleton-loader
        type="text"
        width="45%"
        class="mb-1 flsa-panel-skel-line"
      />
      <v-skeleton-loader
        type="text"
        :width="submissionSecondLineWidth(i)"
        class="flsa-panel-skel-line"
      />
    </div>
  </div>
</template>

<script setup>
const submissionRowCount = 3;

const submissionSecondLineWidth = (index) => {
  const widths = ['88%', '76%', '92%'];

  return widths[index - 1] ?? '85%';
};
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader .v-skeleton-loader__heading),
:deep(.v-skeleton-loader .v-skeleton-loader__text) {
  background: @bg-canvas;
}

:deep(.v-skeleton-loader .v-skeleton-loader__button) {
  background: @bg-canvas;
}

.flsa-panel-skel-title :deep(.v-skeleton-loader__heading) {
  height: 28px;
}

.flsa-panel-skel-section-title :deep(.v-skeleton-loader__heading) {
  height: 28px;
}

.flsa-panel-skel-line :deep(.v-skeleton-loader__text) {
  height: 16px;
  border-radius: 6px;
}

.flsa-panel-skel-label :deep(.v-skeleton-loader__text) {
  height: 16px;
  border-radius: 6px;
}

.flsa-panel-skel-field :deep(.v-skeleton-loader__text) {
  height: 40px;
  border-radius: 8px;
}

.flsa-panel-skel-btn :deep(.v-skeleton-loader__button) {
  height: 40px;
  border-radius: 8px;
  width: 100%;
}

.flsa-panel-or-line {
  border-top: 1px solid @stroke-default;
}

.flsa-panel-skel-or-label :deep(.v-skeleton-loader__text) {
  height: 12px;
  border-radius: 4px;
}

.flsa-panel-skel-pill :deep(.v-skeleton-loader__text) {
  height: 24px;
  border-radius: 24px;
}
</style>
